module.exports = __webpack_public_path__ + "img/v3-tick.ebc047d8.svg";